export const MEETING_HISTORY = "MEETING_HISTORY";
export const CREATE_MEETING = "CREATE_MEETING";
export const POC_LIST_DROPDOWN = "POC_LIST_DROPDOWN";
export const MEETING_BY_ID = "MEETING_BY_ID";
export const CANCEL_MEETING = "CANCEL_MEETING";
export const COMPLETE_MEETING = "COMPLETE_MEETING";
export const VIEW_MOM = "VIEW_MOM";
export const FEEDBACK = "FEEDBACK";
export const FEEDBACK_BY_ID = "FEEDBACK_BY_ID";
export const GET_INVOICES = "GET_INVOICES";
export const CHEQUE_PICKED_LIST = "CHEQUE_PICKED_LIST";
export const SAVE_DRAFT_MEETING = "SAVE_DRAFT_MEETING";
export const SAVE_AS_DRAFT_DATA = "SAVE_AS_DRAFT_DATA";
export const DISCARD_DRAFT = "DISCARD_DRAFT";
export const CHECK_IN_MEETING = "CHECK_IN_MEETING";
export const CX_ORDER_REFUND_LIST = "CX_ORDER_REFUND_LIST";
export const CX_ORDER_REFUND_DATA = "CX_ORDER_REFUND_DATA";
export const CX_ORDER_REFUND_APPROVAL = "CX_ORDER_REFUND_APPROVAL";
export const USERS_LIST_FOR_HOD = "USERS_LIST_FOR_HOD";
export const SAVE_USER_RATING_BY_HOD = "SAVE_USER_RATING_BY_HOD";
export const USER_DATA_BY_USER_ID = "USER_DATA_BY_USER_ID";
export const GET_JUNIOR_LIST = "GET_JUNIOR_LIST";
export const SAVE_MEETING_RATING_BY_SENIOR = "SAVE_MEETING_RATING_BY_SENIOR";
export const EMAIL_DROPDOWN_FILTER = "EMAIL_DROPDOWN_FILTER";
export const SELF_SCORECARD_BY_HOD = "SELF_SCORECARD_BY_HOD";
export const SELF_SCORECARD_BY_SENIOR = "SELF_SCORECARD_BY_SENIOR";
export const NCS_MEETINGS = "NCS_MEETINGS";
export const NCS_MEETINGS_DATA = "NCS_MEETINGS_DATA"

